<div class="container p-2" [formGroup]="getFormGroup()">
    <div class="mb-2  mogo-header-2 text-start p-2 border-bottom">
        Attachments
    </div>
    <div>
        @if (getFormGroup().get('documents')) {
            <app-mogo-dropzone formControlName="documents" height="250px"></app-mogo-dropzone>
        }
    </div>
</div>
